import React, { useState } from 'react';
// import image
import montagneT5California from '../assets/images/location-van-californie-t5-montagne-alpes-toit-relevable.png';
import plageIDBUZZ from '../assets/images/location-van-electrique-idbuzz-plage-atlantique-littoral.jpg';
import villeIDBUZZ from '../assets/images/location-van-electrique-idbuzz-ville-urbain-city-trip.jpg';
import vanInterieurT5 from '../assets/images/van-amenage-interieur-t5-california-lit-cuisine-cosy.jpg';
import vanFrigo from '../assets/images/van-amenage-frigo-refrigerateur-equipement-cuisine.jpg';
import vanEvierEau from '../assets/images/van-amenage-evier-eau-propre-grise.jpg';
import vanGaziniere from '../assets/images/van-amenage-gaziniere-cuisine-bouteille-gaz.png';
import vanT5Exterieur from '../assets/images/van-amenage-exterieur-t5-california-extérieur.png';
import vanChauffage from '../assets/images/van-amenage-chauffage-webasto-hiver-confort.png';
import vanBatterie from '../assets/images/autonomie-electrique-batterie-auxiliaire-van.png';
import vanOcculationFenetre from '../assets/images/occultation-fenetres-van-amenage.jpg';

const VanLife: React.FC = () => {
  const [activeSection, setActiveSection] = useState(0);
  const [activeComfortSection, setActiveComfortSection] = useState(2);
  const [activeInteriorSection, setActiveInteriorSection] = useState(0);

  const handleReservation = () => {
    window.location.href = '/reserver';
  };

  return (
    <div className="min-h-screen bg-white">
      <main className="pt-16"
      style={{
          backgroundImage: `linear-gradient(rgba(239, 246, 255, 1), rgba(219, 234, 254, 1))`,
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          backgroundRepeat: 'no-repeat'
        }}>
        
        {/* Hero Section - Bandeau */}
        <section className="relative overflow-hidden pt-3 pb-6">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            <div className="text-center">
              <h1 className="text-3xl md:text-4xl lg:text-5xl font-bold mb-4 animate-fade-in text-gray-900">
                Vivez l'Aventure
              </h1>
              <p className="text-lg md:text-xl mb-12 max-w-2xl mx-auto animate-slide-up text-gray-700">
                Où que vous alliez, votre van est votre maison
              </p>
              
            </div>
          </div>
        </section>

        {/* Navigation Tabs */}
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 mb-8">
          <div className="flex justify-center border-b border-gray-200 overflow-x-auto">
            <button
              onClick={() => setActiveSection(0)}
              className={`px-4 sm:px-8 md:px-12 py-3 text-base font-medium transition-colors relative ${
                activeSection === 0
                  ? 'text-blue-600'
                  : 'text-gray-600 hover:text-gray-900'
              }`}
            >
              🏖️ Plage
              {activeSection === 0 && (
                <span className="absolute bottom-0 left-0 right-0 h-0.5 bg-blue-600"></span>
              )}
            </button>
            <button
              onClick={() => setActiveSection(1)}
              className={`px-4 sm:px-8 md:px-12 py-3 text-base font-medium transition-colors relative ${
                activeSection === 1
                  ? 'text-blue-600'
                  : 'text-gray-600 hover:text-gray-900'
              }`}
            >
              ⛰️ Montagne
              {activeSection === 1 && (
                <span className="absolute bottom-0 left-0 right-0 h-0.5 bg-blue-600"></span>
              )}
            </button>
            <button
              onClick={() => setActiveSection(2)}
              className={`px-4 sm:px-8 md:px-12 py-3 text-base font-medium transition-colors relative ${
                activeSection === 2
                  ? 'text-blue-600'
                  : 'text-gray-600 hover:text-gray-900'
              }`}
            >
              🏙️ Ville 
              {activeSection === 2 && (
                <span className="absolute bottom-0 left-0 right-0 h-0.5 bg-blue-600"></span>
              )}
            </button>
          </div>
        </div>

        {/* Sliding Sections Container */}
        <div className="relative overflow-hidden">
          <div 
            className="flex transition-transform duration-500 ease-in-out"
            style={{ transform: `translateX(-${activeSection * 100}%)` }}
          >
            {/* Section 1:  🏖️ Plage */}
            <section className="w-full flex-shrink-0 py-12">
              <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
                <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 items-start">
                  {/* Image */}
                  <div className="rounded-2xl overflow-hidden h-80 flex items-end p-4">
                    <img src={plageIDBUZZ} alt="Location van électrique ID.BUZZ Bretagne, Côte atlantique, Côte d'Azur" className="w-full h-full object-cover rounded-2xl" />
                  </div>
                  
                  {/* Content */}
                  <div className="space-y-6">
                    <h2 className="text-3xl md:text-4xl font-bold text-gray-900">
                      Vivez les plus belles plages de France
                    </h2>
                    <p className="text-lg text-gray-700">
                      Electrique, silencieux, stylé.<br></br>⚡Notre ID.BUZZ blanc vous emmène sur les plus belles
                      plages de l'Atlantique sans laisser de trace (sauf vos pas dans le sable).<br></br> Le surf trip
                      éco-responsable commence ici !
                    </p>
                  </div>
                </div>
              </div>
            </section>

            {/* Section 2: ⛰️ Montagne */}
            <section className="w-full flex-shrink-0 py-12">
              <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
                <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 items-start">
                  {/* Image */}
                  <div className="rounded-2xl overflow-hidden h-80 flex items-end p-4">
                    <img src={montagneT5California} alt="Location van aménagé montagne VW California avec toit relevable" className="w-full h-full object-cover rounded-2xl" />
                  </div>
                  
                  {/* Content */}
                  <div className="space-y-6">
                    <h2 className="text-3xl md:text-4xl font-bold text-gray-900">
                      Prenez de la hauteur en VW California
                    </h2>
                    <p className="text-lg text-gray-700">
                      Pourquoi se contenter d'un hôtel 5 étoiles quand on peut dormir sous un milliard d'étoiles ?
                    </p>
                    <p className="text-lg text-gray-700">
                      Réveillez-vous face aux sommets avec notre T5 California.<br></br>
                      Le café a toujours meilleurs goût à 2000m d'altitude !
                    </p>
                  </div>
                </div>
              </div>
            </section>

            {/* Section 3: 🏙️ Ville */}
            <section className="w-full flex-shrink-0 py-12">
              <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
                <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 items-start">
                  {/* Image */}
                  <div className="rounded-2xl overflow-hidden h-80 flex items-end p-4">
                    <img src={villeIDBUZZ} alt="Location van électrique ID.BUZZ stationnement city-trip urbain" className="w-full h-full object-cover rounded-2xl" />
                  </div>
                  
                  {/* Content */}
                  <div className="space-y-6">
                    <h2 className="text-3xl md:text-4xl font-bold text-gray-900">
                      Explorez la ville, dormez où vous voulez
                    </h2>
                    <p className="text-lg text-gray-700">
                      City-trip sans contrainte d'hôtel ? ✨Notre ID.BUZZ compact se faufile partout, se gare facilement.
                    </p>
                    <p className="text-lg text-gray-700">
                      Explorez Paris, Amsterdam, Barcelone ou Genève... et dormez dans les quartiers que vous aimez !
                    </p>
                    
                    {/* Features Grid */}
                    <div className="grid grid-cols-2 gap-4 pt-4">
                      <div className="flex items-center gap-2">
                        <span className="text-2xl">🅿️</span>
                        <span className="text-sm text-gray-700">Stationnement facile en ville</span>
                      </div>
                      <div className="flex items-center gap-2">
                        <span className="text-2xl">⚡</span>
                        <span className="text-sm text-gray-700">100% électrique pour l'urbain</span>
                      </div>
                      <div className="flex items-center gap-2">
                        <span className="text-2xl">🏘️</span>
                        <span className="text-sm text-gray-700">Tous les quartiers accessibles</span>
                      </div>
                      <div className="flex items-center gap-2">
                        <span className="text-2xl">💰</span>
                        <span className="text-sm text-gray-700">Économies sur l'hébergement</span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </section>
          </div>
        </div>

        {/* Section Confort - Tout pour Votre Confort */}
        <section className="py-16 bg-white">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            <div className="text-center mb-12">
              <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">
                Tout pour Votre Confort
              </h2>
              <p className="text-lg text-gray-600">
                Des vans pensés dans les moindres détails
              </p>
            </div>

            {/* Navigation Tabs Confort */}
            <div className="flex justify-center border-b border-gray-200 mb-8 overflow-x-auto">
              <button
                onClick={() => setActiveComfortSection(0)}
                className={`px-4 sm:px-8 md:px-12 py-3 text-base font-medium transition-colors relative ${
                  activeComfortSection === 0
                    ? 'text-blue-600'
                    : 'text-gray-600 hover:text-gray-900'
                }`}
              >
                🌿 Extérieur
                {activeComfortSection === 0 && (
                  <span className="absolute bottom-0 left-0 right-0 h-0.5 bg-blue-600"></span>
                )}
              </button>
              <button
                onClick={() => setActiveComfortSection(1)}
                className={`px-4 sm:px-8 md:px-12 py-3 text-base font-medium transition-colors relative ${
                  activeComfortSection === 1
                    ? 'text-blue-600'
                    : 'text-gray-600 hover:text-gray-900'
                }`}
              >
                🏠 Intérieur
                {activeComfortSection === 1 && (
                  <span className="absolute bottom-0 left-0 right-0 h-0.5 bg-blue-600"></span>
                )}
              </button>
              <button
                onClick={() => setActiveComfortSection(2)}
                className={`px-4 sm:px-8 md:px-12 py-3 text-base font-medium transition-colors relative ${
                  activeComfortSection === 2
                    ? 'text-blue-600'
                    : 'text-gray-600 hover:text-gray-900'
                }`}
              >
                ➕ de CONFORT
                {activeComfortSection === 2 && (
                  <span className="absolute bottom-0 left-0 right-0 h-0.5 bg-blue-600"></span>
                )}
              </button>
            </div>

            {/* Sliding Sections Container Confort */}
            <div className="relative">
                {/* Section 1: Extérieur */}
                {activeComfortSection === 0 && (
                <div className="w-full animate-fade-in">
                  <div className="space-y-6">
                    <h3 className="text-2xl font-bold text-gray-900">
                      Un design moderne et fonctionnel
                    </h3>
                      <div className="w-full h-full flex items-center justify-center rounded-2xl overflow-hidden">
                        <img src={vanT5Exterieur} alt="Extérieur van aménagé T5 California rangements optimisés portes ouvertes" className="w-full h-auto object-cover rounded-2xl" />
                      </div>
                    <p className="text-lg text-gray-700">
                      Compact dehors, spacieux dedans.<br></br>Notre T5 cache bien son jeu : rangements optimisés, accès facile, et un design qui ne passe pas inaperçu.<br></br>Fonctionnel ET stylé, c'est possible !
                    </p>
                  </div>
                </div>
                )}

                {/* Section 2: Intérieur */}
                {activeComfortSection === 1 && (
                <div className="w-full animate-fade-in">
                  {/* Image et texte principal */}
                  <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 items-start mb-12">
                    {/* Image */}
                    <div className="rounded-2xl overflow-hidden h-80 flex items-end p-4">
                      <div className="w-full h-full flex items-center justify-center rounded-2xl">
                        <img src={vanInterieurT5} alt="Intérieur van aménagé T5 California lit confortable cuisine équipée" className="w-full h-full object-cover rounded-2xl" />
                      </div>
                    </div>
                    
                    {/* Content */}
                    <div className="space-y-6">
                      <h3 className="text-3xl md:text-4xl font-bold text-gray-900">
                        Un espace de vie confortable et chaleureux
                      </h3>
                      <p className="text-lg text-gray-700">
                        Votre maison sur roues n'a rien à envier à un appartement parisien.
                      </p>
                      <p className="text-lg text-gray-700">
                        Lit confortable, cuisine équipée, rangements malins... tout le nécessaire pour vivre, pas juste dormir.<br></br>Bienvenue chez vous, partout.
                      </p>
                    </div>
                  </div>

                  {/* Navigation Tabs Intérieur */}
                  <div className="flex justify-center border-b border-gray-200 mb-8 overflow-x-auto">
                    <button
                      onClick={() => setActiveInteriorSection(0)}
                      className={`px-4 sm:px-8 md:px-12 py-3 text-base font-medium transition-colors relative ${
                        activeInteriorSection === 0
                          ? 'text-blue-600'
                          : 'text-gray-600 hover:text-gray-900'
                      }`}
                    >
                      ❄️ Frigo
                      {activeInteriorSection === 0 && (
                        <span className="absolute bottom-0 left-0 right-0 h-0.5 bg-blue-600"></span>
                      )}
                    </button>
                    <button
                      onClick={() => setActiveInteriorSection(1)}
                      className={`px-4 sm:px-8 md:px-12 py-3 text-base font-medium transition-colors relative ${
                        activeInteriorSection === 1
                          ? 'text-blue-600'
                          : 'text-gray-600 hover:text-gray-900'
                      }`}
                    >
                      🚰 Évier + Eau
                      {activeInteriorSection === 1 && (
                        <span className="absolute bottom-0 left-0 right-0 h-0.5 bg-blue-600"></span>
                      )}
                    </button>
                    <button
                      onClick={() => setActiveInteriorSection(2)}
                      className={`px-4 sm:px-8 md:px-12 py-3 text-base font-medium transition-colors relative ${
                        activeInteriorSection === 2
                          ? 'text-blue-600'
                          : 'text-gray-600 hover:text-gray-900'
                      }`}
                    >
                      🔥 Gazinière
                      {activeInteriorSection === 2 && (
                        <span className="absolute bottom-0 left-0 right-0 h-0.5 bg-blue-600"></span>
                      )}
                    </button>
                  </div>

                  {/* Slider Intérieur */}
                  <div className="relative overflow-hidden">
                    <div 
                      className="flex transition-transform duration-500 ease-in-out"
                      style={{ transform: `translateX(-${activeInteriorSection * 100}%)` }}
                    >
                      {/* Sous-section 1: Frigo */}
                      <div className="w-full flex-shrink-0">
                        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 items-start">
                          {/* Image */}
                          <div className="rounded-2xl overflow-hidden h-80 flex items-end p-4">
                            <div className="w-full h-full flex items-center justify-center rounded-2xl bg-gradient-to-br from-blue-100 to-cyan-100">
                              <img src={vanFrigo} alt="Frigo van aménagé" className="w-full h-full object-cover rounded-2xl" />
                            </div>
                          </div>
                          
                          {/* Content */}
                          <div className="space-y-6">
                            <p className="text-lg text-gray-700">
                              Frigo 40L : Vos boissons restent fraîches, vos tomates aussi. La vie de nomade sans compromis !
                            </p>
                          </div>
                        </div>
                      </div>

                      {/* Sous-section 2: Évier + Eau */}
                      <div className="w-full flex-shrink-0">
                        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 items-start">
                          {/* Image */}
                          <div className="rounded-2xl overflow-hidden h-80 flex items-end p-4">
                            <div className="w-full h-full flex items-center justify-center rounded-2xl bg-gradient-to-br from-cyan-100 to-blue-100">
                              <img src={vanEvierEau} alt="Évier et réserve d'eau van aménagé" className="w-full h-full object-cover rounded-2xl" />
                            </div>
                          </div>
                          
                          {/* Content */}
                          <div className="space-y-6">
                            <p className="text-lg text-gray-700">
                              Évier avec réservoirs 30L : Faites la vaisselle avec vue. Même en pleine natutre, on garde le confort !
                            </p>
                          </div>
                        </div>
                      </div>

                      {/* Sous-section 3: Gazinière */}
                      <div className="w-full flex-shrink-0">
                        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 items-start">
                          {/* Image */}
                          <div className="rounded-2xl overflow-hidden h-80 flex items-end p-4">
                            <div className="w-full h-full flex items-center justify-center rounded-2xl bg-gradient-to-br from-orange-100 to-red-100">
                              <img src={vanGaziniere} alt="Gazinière van aménagé" className="w-full h-full object-cover rounded-2xl" />
                            </div>
                          </div>
                          
                          {/* Content */}
                          <div className="space-y-6">
                            <p className="text-lg text-gray-700">
                              Gazinière 2 feux : Café le matin, pâtes le soir. Cuisinez comme à la maison, n'importe où !
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                )}

                {/* Section 3: Supplémentaire */}
                {activeComfortSection === 2 && (
                <div className="w-full animate-fade-in">
                  <div className="space-y-8">
                    {/* Cards Grid */}
                    <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
                      {/* Card 1: Chauffage */}
                      <div className="flex flex-col space-y-4">
                        <h4 className="text-xl font-bold text-gray-900 text-center">🚗 Chauffage Webasto</h4>
                        <div className="rounded-2xl overflow-hidden bg-gray-100 h-64">
                          <img src={vanChauffage} alt="Chauffage Webasto van aménagé confort hiver" className="w-full h-full object-cover" />
                        </div>
                        <p className="text-base text-gray-700 text-center">
                          Chauffage indépendant pour rester au chaud même moteur éteint. L'hiver n'a jamais été aussi confortable !
                        </p>
                      </div>

                      <div className="flex flex-col space-y-4">
                        <h4 className="text-xl font-bold text-gray-900 text-center">🔌 3 jours d'autonomie électrique</h4>
                        <div className="rounded-2xl overflow-hidden bg-gray-100 h-64">
                          <img src={vanBatterie} alt="Batterie auxiliaire et panneaux solaires van aménagé - Autonomie 3 jours" className="w-full h-full object-cover" />
                        </div>
                        <p className="text-base text-gray-700 text-center">
                          Liberté totale ! Grâce à la batterie auxiliaire, vous tenez 3 jours complets sans rouler et sans branchement au réseau électrique. Rechargez vos appareils, allumez les lumières et vivez sereinement où bon vous semble.
                        </p>
                      </div>


                      <div className="flex flex-col space-y-4">
                        <h4 className="text-xl font-bold text-gray-900 text-center">Occultation totale des fenêtres</h4>
                        <div className="rounded-2xl overflow-hidden bg-gray-100 h-64 flex items-center justify-center">
                          <img src={vanOcculationFenetre} alt="Rideaux occultants isolants pour fenêtres de van aménagé" className="w-full h-full object-cover" />
                        </div>
                        <p className="text-base text-gray-700 text-center">
                          Réveillez-vous quand vous en avez envie ! Nos rideaux occultants isolants plongent votre van dans le noir complet. Grasse matinée, sieste improvisée ou nuit tranquille... c'est vous qui décidez.
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
                )}
            </div>
          </div>
        </section>

        {/* CTA Section */}
        <section className="py-20">
          <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
            <div className="bg-white/10 backdrop-blur-sm rounded-2xl p-8 md:p-12"
            style={{
              backgroundImage: `linear-gradient(rgba(59, 130, 246, 1), rgba(37, 99, 235, 1))`,
              backgroundSize: 'cover',
              backgroundPosition: 'center',
              backgroundRepeat: 'no-repeat'
            }}>
              <h2 className="text-3xl md:text-4xl font-bold text-white mb-6">
                🚐 Prêt pour Votre Prochaine Aventure ?
              </h2>
              <p className="text-xl text-white/90 mb-8 max-w-2xl mx-auto">
                Venez vivre des moments inoubliables et créez des souvenirs inoubliables.
              </p>
              <button 
                onClick={handleReservation}
                className="inline-flex items-center px-8 py-4 bg-white text-blue-600 font-semibold rounded-lg hover:bg-gray-50 transition-colors"
              >
                Réserver Maintenant
                <svg className="ml-2 w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 7l5 5m0 0l-5 5m5-5H6" />
                </svg>
              </button>
            </div>
          </div>
        </section>
      </main>
    </div>
  );
};

export default VanLife;